export default __webpack_public_path__ + "static/media/error.ecde7ae8.jpg";